import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { token, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  // Check if user needs to change password
  if (user?.requirePasswordChange && location.pathname !== '/force-password-change') {
    return <Navigate to="/force-password-change" />;
  }

  // Check if user needs to complete onboarding
  if (
    user?.onboardingCompleted === false &&
    !location.pathname.startsWith('/setup') &&
    location.pathname !== '/force-password-change'
  ) {
    return <Navigate to="/setup" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;